const locale = {
  placeholder: 'ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÎ±',
};

export default locale;
